import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';

const Method = () => {
  const { t } = useTranslation();
  
  const principles = [
    { icon: "Sparkles", titleKey: "principle1Title", descKey: "principle1Desc" },
    { icon: "Heart", titleKey: "principle2Title", descKey: "principle2Desc" },
    { icon: "Users", titleKey: "principle3Title", descKey: "principle3Desc" },
    { icon: "Sun", titleKey: "principle4Title", descKey: "principle4Desc" }
  ];

  return (
    <section id="method" className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-green-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('method.title')}
          </h2>
          <p className="text-xl text-purple-700 font-semibold mb-4">
            {t('method.subtitle')}
          </p>
          <p className="text-lg text-gray-600">
            {t('method.description')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {principles.map((principle, index) => {
            const IconComponent = LucideIcons[principle.icon];
            return (
              <Card 
                key={index} 
                className="border-0 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 bg-white group"
              >
                <CardContent className="p-6 text-center">
                  <div className="w-16 h-16 mx-auto bg-gradient-to-br from-pink-100 to-purple-100 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    {IconComponent && <IconComponent className="w-8 h-8 text-pink-600" />}
                  </div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">
                    {t(`method.${principle.titleKey}`)}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {t(`method.${principle.descKey}`)}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Image showcase */}
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_nido-pantano/artifacts/nun0oni4_1000001644.jpg"
              alt="Gioco di gruppo con animali"
              className="w-full h-64 object-cover"
            />
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_nido-pantano/artifacts/vxnzubtl_inbound1606965281327848201.jpg"
              alt="Educazione emotiva"
              className="w-full h-64 object-cover"
            />
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_nido-pantano/artifacts/xi25eerd_inbound8651180575957188576.jpg"
              alt="Autonomia bambini"
              className="w-full h-64 object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Method;
